<template>
  <TopCard v-if="posts" :post="posts[0]"/>
  <GridDisplay title="Recomendados para ti" :method="setRadio" :posts="posts"/>
</template>

<script>
import TopCard from '@/components/TopCard.vue';
import GridDisplay from '@/components/GridDisplay.vue'
export default {
  components: { TopCard, GridDisplay },
    name:'EstacionesView',
    data() {
        return{
            posts: [],
        }    
    },
    mounted(){
        const url= this.baseUrl + '/radio';
        fetch(url)
            .then(response=>response.json())
            .then(json=>this.posts = json.data);
    },
    methods:{
        setRadio(radio){
            const tracklistUrl = radio.tracklist.slice(22)
            fetch(this.baseUrl + tracklistUrl)
                .then(response=>response.json())
                .then(json=>{
                    if(typeof json.data[0]!=='undefined'){
                        localStorage.setItem('currentSong', JSON.stringify(json.data[0]))
                    }
                }) ;
        }
    }
}
</script>